import Vue from 'vue'

// v-dialogDrag: 弹窗拖拽
Vue.directive('dragModal', {
    bind(el, binding, vnode, oldVnode) {
        const dragDom = el.querySelector('.ant-modal')
		const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
		const getStyle = (function () {
		  if (window.document.currentStyle) {
		    return (dom, attr) => dom.currentStyle[attr]
		  } else {
		    return (dom, attr) => getComputedStyle(dom, false)[attr]
		  }
		})()
		
		dragDom.onmousedown = function(ev){
			var ev = ev || window.event;
			var target = ev.target || ev.srcElement;
			if(target.parentNode.className == 'mark-file' || target.parentNode.className == 'mark-lisp'||target.className == 'warp_title'){
				const dialogHeaderEl = target.parentNode;
				dialogHeaderEl.style.cssText += ';cursor:move;user-select:none;'
				dialogHeaderEl.style.cursor = 'move'
					dialogHeaderEl.onmousedown = (e) => {
						const fatherel = el.querySelector('.ant-modal-wrap')
					    // 鼠标按下，计算当前元素距离可视区的距离
					    const disX = e.clientX - dialogHeaderEl.offsetLeft
					    const disY = e.clientY - dialogHeaderEl.offsetTop
					    // 获取到的值带px 正则匹配替换
					    const dragDomWidth = dragDom.offsetWidth
					    const dragDomHeight = dragDom.offsetHeight
					    const screenWidth = fatherel.offsetWidth
					    const screenHeight = fatherel.offsetHeight
					    const minDragDomLeft = dragDom.offsetLeft
					    const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth -10
					    
					    const minDragDomTop = dragDom.offsetTop
					    const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight +10
						// 获取到的值带px 正则匹配替换
						let styL = getStyle(dragDom, 'left')
						let styT = getStyle(dragDom, 'top')
						// let styMT = getStyle(dragDom, 'marginTop')
						// let styMR = getStyle(dragDom, 'marginRight')
						// let styMB = getStyle(dragDom, 'marginBottom')
						// let styML = getStyle(dragDom, 'marginLeft')
						// let styMargin = `${styMT} ${styMR} ${styMB} ${styML}`
					    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
					    if (sty.left.includes('%')) {
					        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
					        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
					    } else {
					        styL = +sty.left.replace(/\px/g, '')
					        styT = +sty.top.replace(/\px/g, '')
					    }
						let left;
						let top;
					    document.onmousemove = function (e) {
							// if (downClient.x !== e.clientX && downClient.x !== e.clientY) {
					        // 通过事件委托，计算移动的距离
					        // const l = e.clientX - disX
					        // const t = e.clientY - disY
							left = e.clientX - disX
							top = e.clientY - disY
							// 边界处理
							if (-(left) > minDragDomLeft) {
							  left = -minDragDomLeft
							} else if (left > maxDragDomLeft) {
							  left = maxDragDomLeft
							}
							
							if (-(top) > minDragDomTop) {
							  top = -minDragDomTop
							} else if (top > maxDragDomTop) {
							  top = maxDragDomTop
							}
					        // 移动当前元素
					        dragDom.style.left = `${left + styL}px`
					        dragDom.style.top = `${top + styT}px`
							// dragDom.style.left = `${l + styL}px`
							// dragDom.style.top = `${t + styT}px`
					        // 将此时的位置传出去
							// }
					    }
					
					    document.onmouseup = function (e) {
					        document.onmousemove = null
					        document.onmouseup = null
					    }
					}
			}
		}
        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);

      
    }
})